export interface MenuItem {
  name: string;
  price30ml?: number;
  priceBotlle?: number;
  pricePint?: number;
  price?: number;
  description?: string;
}

export interface MenuCategory {
  title: string;
  icon: string;
  items: MenuItem[];
}

export const alcoholMenu: MenuCategory[] = [
  {
    title: 'Beer',
    icon: '🍺',
    items: [
      { name: 'Hoegaarden', pricePint: 500 },
      { name: 'Corona', pricePint: 450 },
      { name: 'Kingfisher Ultra Max', pricePint: 430 },
      { name: 'Bira Rise', pricePint: 425 },
      { name: 'Magnum', pricePint: 420 },
      { name: 'Bira White', pricePint: 410 },
      { name: 'Carlsberg', pricePint: 410 },
      { name: 'Budweiser', pricePint: 400 },
      { name: 'Heineken', pricePint: 400 },
      { name: 'Kingfisher Ultra', pricePint: 380 },
      { name: 'Kingfisher Mild', pricePint: 350 }
    ]
  },
  {
    title: 'Vodka',
    icon: '🥃',
    items: [
      { name: 'Beluga', price30ml: 560, priceBotlle: 12320 },
      { name: 'Ciroc', price30ml: 490, priceBotlle: 10780 },
      { name: 'Grey Goose', price30ml: 450, priceBotlle: 9900 },
      { name: 'Ketel One', price30ml: 359, priceBotlle: 7898 },
      { name: 'Absolut Flavours', price30ml: 320, priceBotlle: 7040 },
      { name: 'Smirnoff Flavours', price30ml: 260, priceBotlle: 5720 },
      { name: 'Magic Moments Verve', price30ml: 220, priceBotlle: 4840 }
    ]
  },
  {
    title: 'Blended Scotch',
    icon: '🥃',
    items: [
      { name: 'J W Blue Label', price30ml: 2500, priceBotlle: 55000 },
      { name: 'J W Gold Label', price30ml: 899, priceBotlle: 19700 },
      { name: 'J W Double Black Label', price30ml: 675, priceBotlle: 14850 },
      { name: 'Chivas Regal 12 Yrs', price30ml: 459, priceBotlle: 10098 },
      { name: 'J W Black Label', price30ml: 450, priceBotlle: 9900 },
      { name: '100 Pipers', price30ml: 359, priceBotlle: 7890 },
      { name: 'Black Dog 12 Yrs', price30ml: 359, priceBotlle: 7890 },
      { name: 'J W Red Label', price30ml: 309, priceBotlle: 6790 },
      { name: 'Blenders Pride', price30ml: 269, priceBotlle: 5910 }
    ]
  },
  {
    title: 'Bourbon',
    icon: '🥃',
    items: [
      { name: 'Makers Mark', price30ml: 699, priceBotlle: 15370 },
      { name: 'Jack Daniels', price30ml: 450, priceBotlle: 9900 },
      { name: 'Jack Daniels Honey', price30ml: 450, priceBotlle: 9900 },
      { name: 'Jim Beam', price30ml: 389, priceBotlle: 8550 }
    ]
  },
  {
    title: 'Gin',
    icon: '🥃',
    items: [
      { name: 'Hendricks', price30ml: 300, priceBotlle: 6600 },
      { name: 'Bombay Sapphire', price30ml: 350, priceBotlle: 7700 },
      { name: 'Tanqueray', price30ml: 320, priceBotlle: 7040 },
      { name: 'Beefeater', price30ml: 280, priceBotlle: 6160 },
      { name: 'Gordian', price30ml: 250, priceBotlle: 5500 }
    ]
  },
  {
    title: 'Rum',
    icon: '🥃',
    items: [
      { name: 'Bacardi White Rum', price30ml: 280, priceBotlle: 6160 },
      { name: 'Bacardi Dark Chilli', price30ml: 280, priceBotlle: 6160 },
      { name: 'Captain Morgan', price30ml: 270, priceBotlle: 5940 },
      { name: 'Old Monk Coffee', price30ml: 270, priceBotlle: 5470 },
      { name: 'Old Monk Spiced', price30ml: 210, priceBotlle: 4620 },
      { name: 'Old Monk', price30ml: 210, priceBotlle: 4590 }
    ]
  },
  {
    title: 'Tequila',
    icon: '🥃',
    items: [
      { name: 'Patron', price30ml: 470, priceBotlle: 10340 },
      { name: 'Sierra Silver', price30ml: 400, priceBotlle: 8800 },
      { name: 'Sauza Gold', price30ml: 420, priceBotlle: 9240 },
      { name: 'Camino Blanco', price30ml: 420, priceBotlle: 9240 },
      { name: 'Camino Gold', price30ml: 420, priceBotlle: 9240 },
      { name: 'Don Julio Blanco', price30ml: 390, priceBotlle: 8580 }
    ]
  },
  {
    title: 'Champagne',
    icon: '🍾',
    items: [
      { name: 'The Source Moscato', price30ml: 6750 },
      { name: 'Frizzano Rose', price30ml: 4500 },
      { name: 'Frizzano', price30ml: 4500 },
      { name: 'Frizzano Extra Dry', price30ml: 4500 }
    ]
  },
  {
    title: 'Wine - Red',
    icon: '🍷',
    items: [
      { name: 'Yellow Tail Shiraz', price30ml: 849 },
      { name: "Hardy's Cabernet Sauvignon", price30ml: 649 },
      { name: 'Sula Rass Shiraz', price30ml: 669 },
      { name: 'Good Earth Shiraz', price30ml: 349 }
    ]
  },
  {
    title: 'Wine - White',
    icon: '🍷',
    items: [
      { name: 'Yellow Tail Chardonnay', price30ml: 849 },
      { name: "Hardy's Chardonnay", price30ml: 649 },
      { name: 'Sula Chenin Blanc', price30ml: 369 },
      { name: 'Good Earth White', price30ml: 369 }
    ]
  },
  {
    title: 'Brandy',
    icon: '🥃',
    items: [
      { name: 'Hennessy VSOP', price30ml: 1300, priceBotlle: 27300 },
      { name: 'Hennessy VS', price30ml: 720, priceBotlle: 16160 },
      { name: 'Imperial XO VSOP', price30ml: 350, priceBotlle: 1350 },
      { name: 'Honey Bee', price30ml: 200, priceBotlle: 4000 }
    ]
  },
  {
    title: 'Single Malt',
    icon: '🥃',
    items: [
      { name: 'Glenmorangie', price30ml: 750, priceBotlle: 16500 },
      { name: 'Laphraoig', price30ml: 720, priceBotlle: 15840 },
      { name: 'Glenfiddich 12Yrs', price30ml: 750, priceBotlle: 16500 },
      { name: 'Glenfiddich 15Yrs', price30ml: 850, priceBotlle: 18700 },
      { name: 'Jalliker 12Yrs', price30ml: 650, priceBotlle: 14300 },
      { name: 'Talisker 10Yrs', price30ml: 625, priceBotlle: 13750 },
      { name: 'Ardberg', price30ml: 700, priceBotlle: 15400 },
      { name: 'Ardbeg FUSION', price30ml: 530, priceBotlle: 11660 },
      { name: 'Pan Tao Nirvana', price30ml: 380, priceBotlle: 7700 },
      { name: 'Grants', price30ml: 340, priceBotlle: 6160 }
    ]
  },
  {
    title: 'Cocktail',
    icon: '🍹',
    items: [
      { name: 'LIIT', price30ml: 750 },
      { name: 'Margarita (Tequilla)', price30ml: 600 },
      { name: 'Mint Mojito (Rum)', price30ml: 519 },
      { name: 'Cosmopolitan (Vodka)', price30ml: 499 },
      { name: 'Vodka Cranberry', price30ml: 449 },
      { name: 'Sangria (Wine)', price30ml: 419 }
    ]
  },
  {
    title: 'Mocktail',
    icon: '🥤',
    items: [
      { name: 'Virgin Mojito', price30ml: 450 },
      { name: 'Blue Lagoon', price30ml: 450 },
      { name: 'Ice Tea', price30ml: 400 },
      { name: 'Masala Cola', price30ml: 400 }
    ]
  },
  {
    title: 'Pitcher',
    icon: '🍺',
    items: [
      { name: 'KiKi Punch', price30ml: 2499 },
      { name: 'Margarita', price30ml: 2499 },
      { name: 'Screwdriver', price30ml: 2499 },
      { name: 'Long Island Ice Tea', price30ml: 1999 },
      { name: 'SangriaPit', price30ml: 1499 }
    ]
  },
  {
    title: 'Beverage',
    icon: '🥤',
    items: [
      { name: 'Red Bull', price30ml: 291 },
      { name: 'Coke Zero', price30ml: 200 },
      { name: 'Juice', price30ml: 180 },
      { name: 'Ginger Ale', price30ml: 150 },
      { name: 'Tonic Water', price30ml: 150 },
      { name: 'Cold Drink (Any)', price30ml: 120 },
      { name: 'Soda', price30ml: 100 },
      { name: 'Water', price30ml: 60 }
    ]
  },
  {
    title: 'Shot/Liquor',
    icon: '🥃',
    items: [
      { name: 'Blue Verry Vodka', price30ml: 600 },
      { name: 'Choco Figs Rum', price30ml: 600 },
      { name: 'The Duck Fart', price30ml: 600 },
      { name: 'Irish Bomb', price30ml: 600 },
      { name: 'Slippery Nipple Bar', price30ml: 550 },
      { name: 'Mind Eraser', price30ml: 520 },
      { name: 'Slippery Nipple Bomb', price30ml: 520 },
      { name: 'Vodka Cranberry Shot', price30ml: 480 },
      { name: 'Choco Drop', price30ml: 480 },
      { name: 'Pineapple Sloe Down', price30ml: 480 },
      { name: 'Amaretto', price30ml: 450 },
      { name: 'Campari', price30ml: 450 },
      { name: 'Chartreuse', price30ml: 450 },
      { name: 'Flattiner', price30ml: 450 },
      { name: 'Sambuca', price30ml: 450 },
      { name: 'Jagermeister', price30ml: 450 },
      { name: 'Paan Shot', price30ml: 399 },
      { name: 'Paan Shot', price30ml: 399 },
      { name: 'Coffee Liqueur', price30ml: 369 },
      { name: 'Chilled Vodka Shots', price30ml: 300 }
    ]
  }
];

export const foodMenu: MenuCategory[] = [
  {
    title: 'Soup',
    icon: '🍲',
    items: [
      { name: 'Wild Mushroom & Truffle Oil', description: 'Italy/France - Earthy mushrooms meet rich truffle oil', price: 440 },
      { name: 'Thai Lemongrass & Coconut Soup', description: 'Thailand - Creamy coconut, zesty lemongrass', price: 395 },
      { name: 'Silken Broccoli & Almond Soup', description: 'Modern Cuisine - Velvety broccoli, nutty almond', price: 375 },
      { name: 'Tomato Bisque', description: 'Spain - Smooth, tangy tomato soup', price: 365 }
    ]
  },
  {
    title: 'Salad',
    icon: '🥗',
    items: [
      { name: 'Russian Salad (Olivier)', description: 'Russia - Creamy potato medley with veggies', price: 360 },
      { name: 'Thai Papaya Salad', description: 'Thailand - Tangy, spicy, crunchy green papaya', price: 345 },
      { name: 'Greek Salad', description: 'Greece - Crisp veggies, olives, feta cheese', price: 345 },
      { name: 'Caesar Salad', description: 'USA - Crisp romaine, parmesan, croutons', price: 325 }
    ]
  },
  {
    title: 'Bread & Dip',
    icon: '🍞',
    items: [
      { name: 'Hummus & Pita bread Platter', price: 450 },
      { name: 'Baguette & Garlic butter', price: 395 },
      { name: 'Bruschetta & Garlic bread', price: 350 },
      { name: 'Caprese Sourdough', price: 350 },
      { name: 'Pan con Tomate', price: 290 },
      { name: 'Focaccia with Rosemary', price: 320 },
      { name: 'Focaccia with Roasted Red Pepper', price: 320 }
    ]
  },
  {
    title: 'Small Plates',
    icon: '🍽️',
    items: [
      { name: 'Veg Crystal Dimsum', price: 395 },
      { name: 'Japanese Karaage (10pcs)', price: 400 },
      { name: 'Thai Spring Roll (Veg)', price: 320 },
      { name: 'Thai Spring Roll (Chicken)', price: 340 },
      { name: 'Japanese Ebi Tempura', price: 500 },
      { name: 'Paneer Tikka', price: 450 },
      { name: 'Chicken Tikka', price: 450 },
      { name: 'Tandoori Chicken (Half)', price: 450 },
      { name: 'French Fries', price: 280 }
    ]
  },
  {
    title: 'Big Plates',
    icon: '🍽️',
    items: [
      { name: 'Meatball Marinara with Garlic Bread', description: 'Italy - Saucy meat balls with garlicky bread', price: 580 },
      { name: 'Spaghetti Carbonara', price: 450 },
      { name: 'Penne Arrabbiata', price: 425 },
      { name: 'Thai Green Curry & Steam Rice (Veg)', description: 'Thailand - Fragrant coconut curry', price: 520 },
      { name: 'Thai Green Curry & Steam Rice (Chicken)', description: 'Thailand - Fragrant coconut curry', price: 550 },
      { name: 'Hungarian Chicken Paprikash', description: 'Hungary - Creamy paprika sauce, tender chicken', price: 650 }
    ]
  },
  {
    title: 'Indian Mains',
    icon: '🍛',
    items: [
      { name: 'Paneer Butter Masala', price: 450 },
      { name: 'Chicken Tikka Masala', price: 450 },
      { name: 'Butter Chicken', price: 450 },
      { name: 'Dal Fry or Tadka', price: 350 },
      { name: 'Lucknawi Sabz Biryani', price: 400 },
      { name: 'Chicken Tikka Biryani', price: 450 },
      { name: 'Lazeez Mutton Dum Biryani', price: 550 }
    ]
  },
  {
    title: 'Breads',
    icon: '🍞',
    items: [
      { name: 'Tandoori Roti', price: 40 },
      { name: 'Naan', price: 80 },
      { name: 'Garlic Naan', price: 100 },
      { name: 'Cheese Naan', price: 120 },
      { name: 'Cheese Garlic Naan', price: 145 }
    ]
  },
  {
    title: 'Dessert',
    icon: '🍰',
    items: [
      { name: 'Lotus Biscoff Cheesecake', description: 'Creamy cheesecake with caramelized lotus crunch', price: 300 },
      { name: 'Waffle with Ice-cream', description: 'Crispy warm waffle with creamy vanilla scoop', price: 400 },
      { name: 'Summer Mango Dessert', description: 'Luscious mango delight layered with cream', price: 400 },
      { name: 'Brownie Ice-cream', description: 'Fudgy brownie paired with ice cream', price: 380 }
    ]
  }
];
